import { styledByTheme } from '../../../../themes/architecture/styled-by-theme';
import { MiniOrbitHomePageDefaultBox } from './mini-orbit-home-page.default.box';
import { MiniOrbitHomePageSiCisBox } from './mini-orbit-home-page.siCis.box';

export const MiniOrbitHomePageBox = styledByTheme(MiniOrbitHomePageDefaultBox)
    .forSICis(MiniOrbitHomePageSiCisBox)
    .apply();